export default __webpack_public_path__ + "locales/az/FilesSettings.json?hash=e4ff1f9b590cd77ce33a58f2fd7cc79d";